import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Redirect } from 'react-router-dom'

function AdminLogout(props) {

    const { licenseName } = useParams();
    var [license] = useState(licenseName);

    useEffect(() => {
        const doLogout = async () => {
            const query = `/api/${license}/logout`;
            await fetch(query,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    credentials: 'include',
                    cors: 'cors'
                });
        }
        doLogout();
    }, [license]);

    var target = `/${license}/login`;
    return (
        <Redirect to={target} />
    );

}

export default AdminLogout;